export const warehouseOptions = {
  DELIVER: '出库',
  STORE: '入库',
  DELIVER_STORE: '出入库',
};

export const COLUMN = [
  {
    label: '企业信用代码',
    prop: 'creditCode',
    minWidth: 240,
  },
  {
    label: '客户名称',
    prop: 'customerName',
    minWidth: 240,
    showOverflowTooltip: true,
  },
  {
    label: '客户所属租户编码',
    prop: 'tenantId',
    minWidth: 180,
    showOverflowTooltip: true,
  },
  {
    label: '租户名称',
    prop: 'tenantName',
    minWidth: 150,
    showOverflowTooltip: true,
  },
  {
    label: '运营项目',
    prop: 'project',
    minWidth: 150,
    showOverflowTooltip: true,
    formatter: (row) => {
      const list = [];
      (row.warehouseTransferProjectList || []).forEach((item) => {
        list.push(item.projectName);
      });
      return list.join(',');
    },
  },
  {
    label: '出入库类型',
    prop: 'type',
    minWidth: 180,
    formatter: (row) => warehouseOptions[row.type],
  },
  {
    label: '区域',
    prop: 'areas',
    minWidth: 200,
    showOverflowTooltip: true,
    formatter: (row) => {
      const list = [];
      (row.warehouseTransferAreaList || []).forEach((item) => {
        list.push(item.allCity ? item.province : item.city);
      });
      return list.join(',');
    },
  },
  {
    label: '原始客户名称',
    prop: 'originalCustomerName',
    minWidth: 180,
    showOverflowTooltip: true,
  },
  {
    label: '转仓路径',
    prop: 'warehouseTransferRuleListText',
    minWidth: 250,
    showOverflowTooltip: true,
  },
  {
    label: '合同链路',
    prop: 'warehouseTransferRuleListContract',
    minWidth: 250,
    showOverflowTooltip: true,
  },
  {
    label: '创建人',
    prop: 'createUserName',
    minWidth: 120,
    showOverflowTooltip: true,
  },
  {
    label: '创建时间',
    prop: 'createTime',
    minWidth: 160,
    showOverflowTooltip: true,
  },
  {
    label: '操作',
    prop: 'active',
    minWidth: 180,
    fixed: 'right',
  },
];

// 订单校验规则配置页面字段
export const tranWareField = {
  GOODS_RULE: [
    {
      label: '客户',
      colSpan: 12,
      prop: 'customer',
      slot: 'customer',
    },
    {
      label: '原始客户',
      colSpan: 12,
      prop: 'originalCustomer',
      slot: 'originalCustomer',
    },
    {
      label: '出库类型',
      colSpan: 12,
      prop: 'type',
      slot: 'type',
    },
  ],
  ADDITIONAL_RULE: [
    {
      label: '请选择下单货主的运营项目(选填)',
      colSpan: 24,
      prop: 'project',
      slot: 'project',
    },
    {
      label: '请选择要配送的收货区域(选填)',
      colSpan: 24,
      prop: 'areas',
      slot: 'areas',
    },
  ],
};

// 转仓链路列表
export const tableColumn = [
  {
    label: '企业货主名称',
    prop: 'tenantId',
  },
  {
    label: '指定仓合同',
    prop: 'contractCode',
  },
  {
    label: '运营项目',
    prop: 'projectId',
  },
  {
    label: '操作',
    prop: 'active',
    width: '100',
    fixed: 'right',
  },
];

// 表更记录
export const CHANGE_TEXT = [
  {
    prop: 'customerName',
    name: '客户',
  },
  {
    prop: 'typeText',
    name: '出入库类型',
  },
  {
    prop: 'originalCustomerName',
    name: '原始客户',
  },
  // {
  //   prop: 'project',
  //   name: '运营项目',
  // },
  // {
  //   prop: 'areas',
  //   name: '收货区域',
  //   tooltipLength: 10,
  // },
];

export const CONDITION_TEXT = [
  {
    prop: 'project',
    name: '运营项目',
  },
  {
    prop: 'areas',
    name: '收货区域',
    tooltipLength: 10,
  },
];

export const changetableColumn = [
  {
    label: '企业货主名称',
    prop: 'tenantName',
  },
  {
    label: '指定仓合同',
    prop: 'contractName',
  },
];

// 仓储流程配置相关
// 订单校验规则配置页面字段
export const tranWareFieldWareHouse = {
  GOODS_RULE: [
    {
      label: '客户',
      colSpan: 12,
      prop: 'customer',
      slot: 'customer',
    },
    {
      label: '仓货主',
      colSpan: 12,
      prop: 'originalCustomer',
      slot: 'originalCustomer',
    },
    {
      label: '出库类型',
      colSpan: 12,
      prop: 'type',
      slot: 'type',
    },
  ],
  ADDITIONAL_RULE: [
    {
      label: '请选择下单货主的运营项目(选填)',
      colSpan: 24,
      prop: 'project',
      slot: 'project',
    },
    {
      label: '请选择要配送的收货区域(选填)',
      colSpan: 24,
      prop: 'areas',
      slot: 'areas',
    },
  ],
};
